import { render, staticRenderFns } from "./ModalClonar.vue?vue&type=template&id=93654842"
import script from "./ModalClonar.vue?vue&type=script&lang=js"
export * from "./ModalClonar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports